export default __webpack_public_path__ + "static/media/LogoDielPowered.d9792c28.svg";